import type {ReducersMapObject} from 'redux'
import {combineReducers as reduxCombineReducers} from 'redux'

import {hasPerformanceReducerLog} from '../utils/logger'
import {performanceCallback} from '../utils/performanceCallback'

export const combineReducers = <R extends ReducersMapObject>(reducers: R) => {
  if (hasPerformanceReducerLog) {
    const perfReducers = Object.fromEntries(
      Object.entries(reducers).map(([key, reducer]) => [key, performanceCallback(key, reducer)]),
    ) as R
    return reduxCombineReducers(perfReducers)
  } else {
    return reduxCombineReducers(reducers)
  }
}
